import React, { useMemo } from 'react';
import cn from 'classnames';
import * as PropTypes from 'prop-types';

import Icon from '../Icon';

import { APP_STORE_APP_LINK, PLAY_MARKET_APP_LINK } from '../../constants/env';

import checkIsAppStoreLinksAvailability from '../../utils/checkIsAppStoreLinksAvailability';

import styles from './styles.styl';

const logoSize = {
  width: 150,
  height: 45,
};

function MobileAppLogo({ className }) {
  const { showAppStoreLink, showPlayMarketLink } = useMemo(
    () => checkIsAppStoreLinksAvailability(),
    [],
  );

  return (
    <div className={cn(styles.root, className)}>
      {showPlayMarketLink && (
        <a
          href={PLAY_MARKET_APP_LINK}
          rel="noopener noreferrer"
          target="_blank"
        >
          <Icon name="googlePlayLogo" {...logoSize} />
        </a>
      )}
      {showAppStoreLink && (
        <a href={APP_STORE_APP_LINK} rel="noopener noreferrer" target="_blank">
          <Icon name="appStoreLogo" {...logoSize} />
        </a>
      )}
    </div>
  );
}

MobileAppLogo.propTypes = {
  className: PropTypes.string,
};

export default MobileAppLogo;



// WEBPACK FOOTER //
// ./src/components/MobileAppLogo/index.jsx